import moment from 'moment-timezone';

export const globalMixin = {
    computed: {
		roleId() {
			return this.$store.state.loggedUser?.role_id;
		},
		isSuperAdmin() {
			return this.roleId === 1;
		},
		isSuperOrAdmin() {
			return [1, 2].includes(this.roleId);
		},
		isSalesHead() {
			return this.roleId === 3;
		},
		isSalesTL() {
			return this.roleId === 4;
		},
		isSalesMember() {
			return this.roleId === 5;
		},
	},
    methods: {
        formatDate(date, slash) {
            if(slash){
                return date ? moment(date).tz('Asia/Manila').format('MM/DD/YYYY') : "";
            }
            return date ? moment(date).tz('Asia/Manila').format('YYYY-MM-DD') : "";
        },
        formatDateTime(dateTime) {
            return dateTime ? moment(dateTime).tz('Asia/Manila').format('YYYY-MM-DD hh:mm A') : "";
        },
        formatDecimal(data) {
            return parseFloat(data).toLocaleString('en-PH', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
        },
        formatToMoney(data){
            return parseFloat(data).toLocaleString('en-PH', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        },
        formatToHrs(dateTime) {
            const now = new Date();
            const createdTime = new Date(dateTime);
            const diffInMs = now - createdTime; // Difference in milliseconds
            const diffInHrs = diffInMs / (1000 * 60 * 60); // Convert to hours
            return diffInHrs.toLocaleString('en-PH', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
        },
        formatNameDate(name, date) {
            const _name = name ? name.first_name + ' ' + name.last_name + ' - ': '';
            const _date = date ? moment(date).tz('Asia/Manila').format('YYYY-MM-DD hh:mm A') : "";
            return _name && _date ? _name + _date : '';
        },
        getLabel(list, key) {
            const type = list.find(item => item.key === key);
            return type ? type.value : 'None';
        },
        formatText(key){
            return key.replace(/_/g, " ").replace(/\b\w/g, l => l.toUpperCase()) + ":";
        },
        handleInputChange(field, event) {
            if (field.attrs?.preserveText) {
                return this.data[field.name] = event.target.value;
            } else if (field.attrs?.allCaps) {
                return this.data[field.name] = event.target.value.toUpperCase();
            } else {
                if(field.name !== 'email'){
                    event.target.value = event.target.value.charAt(0).toUpperCase() + event.target.value.slice(1).toLowerCase();
                }
                return this.data[field.name] = event.target.value;
            }
        },
        //---------should be changed based on the user permission
        canProcessOrder(status) {
            console.log('canProcessOrder', this.$store.state.loggedUser,this.roles,  this.roles.some(role => [1, 2, 6].includes(role.id)) && status === 1)
            return this.roles.some(role => [1, 2, 6].includes(role.id)) && status === 2;
        },
        canApprove(status) {
            console.log('canApprove', status);
            return [1, 2, 6].some(role => this.roles.includes(role.id)) && status === 3;
        },
        canUpdateToServe(status) {
            console.log('canUpdateToServe',status);
            return [1, 2, 6].some(role => this.roles.includes(role.id)) && status === 3;
        },
        canCancel(status){
            console.log('canCancel',status);
            return [2].some(role => this.roles.includes(role)) && status === 2;
        },
        //---------should be changed based on the user permission
		removePrefix(string) {
            return string.split('#')[1];
        },
		isGuestAccount(user){
            const roles = user?.user_roles || [];
            return roles.some(role => Number(role.id) === 10);
        },
		formatIntegersOnly(event) {
            const value = event.target.value.replace(/\D/g, '');
            return value;
        },
    },
};
